module.exports = new __parcel__URL__("mid-tom_8.73bfd563.mp3").toString();